module.exports = __webpack_public_path__ + "img/template-strucutre.b78b7816.jpg";